import React from "react";

const CancelOrder = () => {
  return (
    <div>
      <h1>Cancel</h1>
      <h2>Your payment was canceled.</h2>
    </div>
  );
};

export default CancelOrder;
